import { StyleSheet } from 'react-native';

import { neutralDark, warrior } from '../../../constants/color';

const styles: any = StyleSheet.create({
  billDetailSection: {
    paddingVertical: 10,
    paddingHorizontal: 15,
    justifyContent: 'center',
  },

  dataField: {
    flexDirection: 'row',
    marginVertical: 5,
  },
  addressCardField: {
    marginBottom: 5,
    flex: 1,
  },
  dataKeyText: {
    lineHeight: 21,
    fontSize: 15,
    color: neutralDark,
  },
  dataValueLayout: {
    justifyContent: 'center',
  },
  dataValueText: {
    flex: 1,
    fontSize: 15,
    lineHeight: 21,
    color: warrior,
  },
  receiptStyle: {
    marginTop: 5,
  },
});

export default styles;
